import React from 'react'
import { Col, Card, CardHeader, CardBody, Button } from 'reactstrap'

// Add New and Delete Buttons

export default function KnowledgeMapControls (props) {
  return (
      <Col xs={props.xs} lg={props.lg}>
        <Card>
          <CardBody>
            <Button color='success' onClick={props.addNewNode}>+ Add New</Button>{' '}
            <Button color='primary' disabled={!props.isChanged} onClick={props.saveChanges}>Save</Button>{' '}
            <Button color='danger' disabled={props.deleteDisabled} onClick={props.deleteNode}>Delete</Button>
          </CardBody>
        </Card>
      </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/KnowledgeMap/KnowledgeMapControls.js